const namespace = 'clinicPatient';

export const FETCH_VIRTUAL_CLINIC_PATIENT_APPOINTMENTS = `${namespace}/FETCH_VIRTUAL_CLINIC_PATIENT_APPOINTMENTS`;
export const SET_VIRTUAL_CLINIC_PATIENT_APPOINTMENTS = `${namespace}/SET_VIRTUAL_CLINIC_PATIENT_APPOINTMENTS`;
export const SET_VIRTUAL_CLINIC_PATIENT_APPOINTMENTS_PAGE = `${namespace}/SET_VIRTUAL_CLINIC_PATIENT_APPOINTMENTS_PAGE`;
export const SET_VIRTUAL_CLINIC_PATIENT_APPOINTMENTS_SORT_ORDER = `${namespace}/SET_VIRTUAL_CLINIC_PATIENT_APPOINTMENTS_SORT_ORDER`;
